import { COLORS } from '@btime/constants'
import { FilterHandler } from '@btime/react-contexts'
import { useTranslation } from 'react-i18next'
import React from 'react'

import { Title } from '../../../components/presentation/Text'
import ControlledModal from '../../../components/modals/ControlledModal'
import DocTemplateTable from './table/TemplateRecordHistoryTable'
import Scroll from '../../../components/helpers/Scroll'
import TemplateRecordLoader from './_load/TemplateRecordLoader'

const TemplateRecordsModal = props => {
  const { t } = useTranslation('templates')
  return (
    <ControlledModal width="48rem" {...props}>
      <FilterHandler tempStorageNamespace="templateRecords" initialState={{}}>
        <TemplateRecordLoader>
          <Title size="h5" strong color={COLORS.dark2} noMargin>
            {t('docsHistory')}
          </Title>
          <DocTemplateTable />
        </TemplateRecordLoader>
      </FilterHandler>
    </ControlledModal>
  )
}

export default TemplateRecordsModal
